import apiClient from '../apiClient';
import { getAssignedMachine, setAssignedMachine } from '../operatorSessionService';
import { trackPromise } from 'react-promise-tracker';
import { offlineGet } from '../helpers/offlineHelpers';

async function listEnabledMachines() {
    const { data } = await apiClient.get('/api/machine/getAllEnabled');
    return data?.data ?? [];
}

async function listMachines() {
    const { data } = await trackPromise(apiClient.get('/api/machine/getAll'));
    return data?.data ?? [];
}

async function getMachineById(id) {
    const { data } = await trackPromise(apiClient.get(`/api/machine/getById/${id}`));
    return data?.data ?? null;
}

async function getMyAssignedMachine(userId) {
    // const { data } = await trackPromise(apiClient.get('/api/production/machines/assigment/my'));
    // return data?.data ?? null;
    return trackPromise(
        offlineGet(
            `assigned-machine-${userId}`,
            () => apiClient.get('/api/production/machines/assigment/my'),
            (res) => res.data?.data ?? null
        )
    );
}

async function assignMachine(machine) {
    setAssignedMachine(machine);
    return machine;
}

async function unassignMachine() {
    setAssignedMachine(null);
}

function getCurrentAssignment() {
    return getAssignedMachine();
}

async function addMachine(machine) {
    const { data } = await trackPromise(apiClient.post('/api/machine/add', machine));
    return data;
}

async function updateMachine(id, newData) {
    const { data } = await trackPromise(apiClient.put(`/api/machine/updateById/${id}`, newData));
    return data;
}

async function enabledDisableMachine(id) {
    const { data } = await trackPromise(apiClient.put(`/api/machine/enabledDisable/${id}`));
    return data;
}

const machineService = {
    listEnabledMachines,
    listMachines,
    getMachineById,
    getMyAssignedMachine,
    assignMachine,
    unassignMachine,
    getCurrentAssignment,
    addMachine,
    updateMachine,
    enabledDisableMachine
};

export default machineService;
